import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app';
import { useSession } from '../stores/session';
import { isLuxembourgEmail } from '../utils/luxembourg-email';

export default defineNuxtRouteMiddleware(() => {
  const sessionStore = useSession();
  if (isLuxembourgEmail(sessionStore.getEmail)) {
    return navigateTo('/course', { replace: true });
  }
});
